export default "__VITE_ASSET__1c126581__"